import { render, staticRenderFns } from "./DataGroup.vue?vue&type=template&id=48d509cb"
import script from "./DataGroup.vue?vue&type=script&lang=js"
export * from "./DataGroup.vue?vue&type=script&lang=js"
import style0 from "./DataGroup.vue?vue&type=style&index=0&id=48d509cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports